import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/thermometer-sun.vue
var s = {
	name: "DtIconThermometerSun",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--thermometer-sun"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Thermometer Sun",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M4.46 4.505A2.5 2.5 0 0 1 6.009 4a.5.5 0 0 1-.016 1 1.5 1.5 0 0 0-.75 2.812.5.5 0 1 1-.484.876 2.5 2.5 0 0 1-.297-4.183ZM6 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 6 1ZM3.654 8.846a.5.5 0 0 1 0 .708l-.7.7a.5.5 0 0 1-.708-.708l.7-.7a.5.5 0 0 1 .708 0ZM9 1.5a.5.5 0 0 0-.5.5v5.27a.5.5 0 0 1-.25.433 1.5 1.5 0 1 0 1.5 0 .5.5 0 0 1-.25-.433V2a.5.5 0 0 0-.5-.5ZM7.94.94A1.5 1.5 0 0 1 10.5 2v5.002a2.5 2.5 0 1 1-3 0V2c0-.398.158-.78.44-1.06ZM.5 6.5A.5.5 0 0 1 1 6h1a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm1.611-3.889a.5.5 0 0 1 .708 0l.705.705a.5.5 0 1 1-.708.708l-.705-.705a.5.5 0 0 1 0-.708Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=thermometer-sun.js.map